import React, { FC } from 'react';

import { MainStyle } from './mainStyles';


export const Main: FC = props =>
    <MainStyle size='full' forwardedAs='main' {...props} />;
